<template>
  <MaintenanceNotice :statusData="maintenanceStatusData" :maintenanceType="MaintenanceType.GLOBAL" />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { webStatus } from '@/api/lambdaApiService.js';
import MaintenanceNotice, { MaintenanceType } from '@/components/MaintenanceNotice.vue';

const maintenanceStatusData = ref({});

onMounted(async () => {
  try {
    const response = await webStatus();
    maintenanceStatusData.value = response.data;
  } catch (error) {
    console.error('Error fetching web status:', error);
  }
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/maintenancePage.scss';
</style>
